import { OrigemDocumentoFiscalEmitidoEnum } from '../../../enums/repo-dfe/origem-documento-fiscal-emitido.enum';

export class DocumentoFiscalEmitidoDownloadStruct {
    idDocumentoFiscalEmitido: number = 0;
    origemDocumentoFiscalEmitido: OrigemDocumentoFiscalEmitidoEnum = OrigemDocumentoFiscalEmitidoEnum.EstruturaAntiga;
}
